var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 1.492a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m-6.5 5.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.411 7.903q.001-.296.056-.512.057-.216.192-.408.144-.2.392-.408.28-.24.432-.4.153-.168.208-.32a1 1 0 0 0 .064-.384q0-.344-.216-.528-.207-.184-.584-.184-.351 0-.648.104a4 4 0 0 0-.24.089.39.39 0 0 1-.497-.18.337.337 0 0 1 .158-.462 3.05 3.05 0 0 1 1.292-.27q.744 0 1.151.384t.408 1.024a1.43 1.43 0 0 1-.416 1.048 6 6 0 0 1-.464.448q-.24.216-.368.368a.9.9 0 0 0-.176.304 1.4 1.4 0 0 0-.04.36.16.16 0 0 1-.16.16h-.312a.23.23 0 0 1-.232-.232ZM6.243 9.36q0-.312.16-.44a.6.6 0 0 1 .392-.128q.217 0 .376.128.168.128.168.44c0 .312-.056.357-.168.448a.56.56 0 0 1-.376.136.59.59 0 0 1-.392-.136q-.16-.136-.16-.448"
  })));
};
export default SvgQuestionMark;